/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  Range,
  AdvanceEventOutcomesHistory,
} from '..';
import {
  serializeRange,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetAdvanceEventOutcomesHistoryInput {
  plantId: string;
  range: Range;
}
const build = (_query: DocumentNode, input: GetAdvanceEventOutcomesHistoryInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.plantId !== undefined ? `$plantId: String = ${JSON.stringify(input.plantId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.range !== undefined ? `$range: Range = ${serializeRange(input.range)}` : '' ) + `){
    getAdvanceEventOutcomesHistory(
      ${ input.plantId !== undefined ? 'plantId: $plantId,' : '' } 
      ${ input.range !== undefined ? 'range: $range,' : '' }
    ){
      ...advanceeventoutcomeshistory
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetAdvanceEventOutcomesHistoryQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment advanceeventoutcomeshistory on AdvanceEventOutcomesHistory { ... }
   */
  async execute(_query: DocumentNode, input: GetAdvanceEventOutcomesHistoryInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getAdvanceEventOutcomesHistory: Partial<AdvanceEventOutcomesHistory>[] }>({ query: build(_query, input), fetchPolicy });
  }
}
